//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getCoupon
} from '../../api';
export default {
    props: ['list'],
    methods: {
        detailTap(res) {
            if (res.isCheckDetail) {
                res.isCheckDetail = false;
            } else {
                this.$set(res, 'isCheckDetail', true);
            }
        },
        receive(res) {
            getCoupon(`coupon_id=${res.coupon_id}`).then(res => {
                if (res.data.error_code) {
                    this.$store.commit('updateToast', {
                        show: true,
                        text: res.data.msg
                    });
                    console.error(res);
                    return;
                };
                this.$store.commit('updateToast', {
                    show: true,
                    text: '领取成功'
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/HomeCoupon/list.vue